import { CustomerDetailsTab } from '@/views/customerDetails/model/CustomerDetailsTab.model.ts';

export type CustomerDetailsTabsTranslation = Record<CustomerDetailsTab, string>;

export const customerDetailsTabsTranslation: CustomerDetailsTabsTranslation = {
  [CustomerDetailsTab.CONTACTS]: 'Kontakty',
  [CustomerDetailsTab.MAIN]: 'Szczegóły',
  [CustomerDetailsTab.PROCESSES]: 'Procesy',
  [CustomerDetailsTab.RECURRING_RESERVATIONS]: 'Rezerwacje stałe',
  [CustomerDetailsTab.TASKS]: 'Zadania',
};
